import React, { useEffect, useState } from 'react';
import './Palmleaf.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import PALMLEAFHAND from '../images/PALMLEAFHAND.webp';
import COSMICPALMNADI from '../images/COSMICPALMNADI.webp';
import OLAICHUVADIPALM from '../images/OLAICHUVADIPALM.jpg';
import ASTROLOGYSOLUTIONS from '../images/ASTROLOGYSOLUTIONS.png';
import WORLDMAPJPG from '../images/WORLDMAPJPG.jpg'; // Adjust path as necessary
import PALMLEAF from '../images/PALMLEAF.webp'; // Adjust path as necessary 
import Reviews from './Reviews';
import Topbar from './Topbar';
import Remedycard from './Remedycard';



export default function Palmleaf() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // State to manage open/close state of each FAQ item
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index); // Close if already open, otherwise open
  };


  return (
    <div>
      
    <div><Navbar /></div>
    <div>
      <section id="hero" style={{ backgroundImage: `url(${PALMLEAF})` }}>
        <div className="hero-content">
          <h1><span id="SHIVA"> SHIVA NADI ASTROLOGY</span></h1>
          <p>Ancient Wisdom | Future Insights</p>
          <center>
            <p id="langu">Telugu | Hindi | Malayalam | Tamil | English</p>
            </center>
          <a href="tel:+917402167580" className="hero-btn">Get Appointment?</a>
        </div>
      </section>

      <section id="About">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
              <h2>About</h2>
              Welcome to Shiva Nadi Astrology!
With over 32 years of profound expertise, we are proud to be your trusted guide in unveiling the divine secrets of your life through the ancient wisdom of Nadi Astrology. We understand that knowing your life path is essential for spiritual and personal success, and our dedicated team ensures a seamless and enlightening journey tailored to align with your destiny.

At Shiva Nadi Astrology, transparency is the foundation of our service. We value the trust of our clients and ensure clarity at every stage of your consultation. Our experienced astrologers provide detailed insights into your past, present, and future, empowering you to make confident decisions and embrace your spiritual path with assurance.

Your satisfaction and spiritual growth are our highest priorities. Whether you seek answers about your life purpose, career, relationships, or spiritual journey, we are committed to offering accurate readings and compassionate guidance. From locating your unique palm leaf to interpreting its divine messages, Shiva Nadi Astrology stands by you to illuminate your path to fulfillment.

Choose Shiva Nadi Astrology for unmatched expertise and excellence in unlocking the wisdom of the ancients. Let us help you achieve clarity, peace, and alignment with your divine purpose!
            </div>
          </div>
        </div>
      </section>



      <section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<h2>Ancient Wisdom | Future Insights</h2>


</div>

</div>

</div>
</section>
<section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<img src={WORLDMAPJPG} alt="Gallery Image 1" className="img-fluid rounded" />

</div>
<h5>We Offer Our Service All Over The World</h5>
</div>

</div>
</section>





<section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={PALMLEAFHAND} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Palm Nadi Astrology</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Palm Nadi Astrology takes pride in offering a seamless and transparent journey into the divine wisdom of your life. With over 32 years of expertise in the sacred practice of Nadi Astrology, our dedicated team ensures you uncover the profound insights and guidance written in your unique palm leaf, tailored to illuminate your life path and spiritual purpose.

We understand that discovering your destiny is a transformative experience, and we are here to guide you every step of the way. From locating your personalized Nadi palm leaf to interpreting its sacred messages, our experienced astrologers ensure a smooth and enlightening process designed to meet your spiritual needs.

At Palm Nadi Astrology, trust is the foundation of our service. We are committed to maintaining transparency in every aspect, offering clear and honest communication throughout your journey. Our mission is to empower you with the divine knowledge to make confident and meaningful decisions, helping you align with your higher purpose and achieve inner harmony.

Choose Palm Nadi Astrology—your trusted partner in unlocking the ancient secrets of your life, with unwavering reliability and care. Let us help you discover the wisdom inscribed in your Nadi leaf and embrace a life of clarity, peace, and fulfillment!</p>
    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={COSMICPALMNADI} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Life Prediction</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>At Palm Leaf Nadi Astrology, we provide affordable and insightful predictions that help you understand your life's true purpose, without the need for complicated methods or confusion. With over 16 years of trusted expertise, our experienced team specializes in uncovering the ancient wisdom inscribed on your unique palm leaf, offering predictions that guide you toward spiritual growth and personal fulfillment.

We prioritize transparency in our readings, offering clear, honest insights into your past, present, and future, tailored specifically to your life's journey. Our dedicated astrologers ensure a seamless process, guiding you through each stage, from locating your palm leaf to interpreting its sacred messages, helping you align your decisions with your true path.

Whether you're seeking clarity about your career, relationships, or spiritual journey, Palm Leaf Nadi Astrology is committed to providing timely and accurate predictions that empower you to live with confidence and purpose. Choose Palm Leaf Nadi Astrology for a reliable and transformative experience that illuminates your life's path.</p>
    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={OLAICHUVADIPALM} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Ancient Astrology</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Palm Leaf Nadi Astrology is your trusted guide for discovering the ancient wisdom written in your palm leaf, unlocking the secrets of your life’s path. With over 16 years of experience in Nadi Astrology, we specialize in connecting you to the profound insights inscribed on your unique palm leaf, offering predictions that reveal your destiny in a clear and reliable manner.

At Palm Leaf Nadi Astrology, we prioritize transparency and honesty. Our experienced astrologers provide clear guidance with competitive pricing, ensuring that every aspect of your reading is straightforward and easy to understand. We follow the traditional and ancient methods of Nadi reading, offering dependable assistance throughout the process, from locating your palm leaf to interpreting its divine messages.

Our team ensures that each prediction is carefully analyzed and personalized to your specific needs, offering you a seamless and enlightening experience. We are committed to providing fast, efficient, and accurate readings, helping you gain clarity on your life’s journey, relationships, career, and spiritual path.

Choose Palm Leaf Nadi Astrology for a reliable, transformative experience and let us help you uncover the divine wisdom that guides your life.</p>
    </div>
  </div>


 {/* Row 2 */}
 <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={ASTROLOGYSOLUTIONS} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Solutions</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Personalized Life Path Insights:
Our experienced astrologers will help you uncover your unique life path, providing clarity on your past, present, and future. Through the ancient process of Nadi reading, we can offer guidance on major life events, career choices, relationships, and spiritual growth, ensuring you make informed decisions.

Understanding and Resolving Life Challenges:
Whether you're facing difficulties in relationships, career, health, or finances, Nadi Astrology helps identify the root cause of these issues. By interpreting the messages in your palm leaf, we provide actionable advice to help resolve these challenges and restore harmony in your life.

Marriage and Relationship Guidance:
Palm Leaf Nadi Astrology can offer profound insights into your relationships, including marriage compatibility, emotional connections, and future prospects. We guide you toward making the right decisions that will lead to long-lasting and fulfilling relationships.

Career and Financial Guidance:
By analyzing the information in your palm leaf, we can identify your strengths and weaknesses, offering advice on your career path, job changes, and financial prosperity. Our predictions provide clarity on the best steps to take for success and wealth.

Health and Wellness Predictions:
Nadi readings can also provide valuable insights into your health, including possible ailments or issues that may arise in the future. By understanding your health patterns, we suggest preventive measures and remedies to maintain good physical and mental well-being.

Spiritual Guidance:
We provide spiritual solutions to help you connect with your higher self and overcome any obstacles in your spiritual journey. Nadi astrology can offer specific remedies such as prayers, rituals, or mantras to bring peace and positivity into your life.

Timely Remedies for Problems:
Nadi astrology not only predicts future events but also offers remedies and spiritual practices to resolve difficulties. These remedies may include specific rituals, gemstones, mantras, or other traditional methods to bring balance and prosperity to your life.</p>
    </div>
  </div>


</section>
    

<section id="why-choose-us">
  <div class="container">
    <h2>Why Choose Us?</h2>
    <div class="features">
      <div class="feature-box">
        <i class="icon fas fa-star"></i>
        <h3>Ancient Expertise</h3>
        <p>With centuries of experience, we provide authentic insights through traditional Nadi astrology.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-heart"></i>
        <h3>Client-Centered Approach</h3>
        <p>Your well-being is our priority. We go beyond predictions to offer personalized guidance for your spiritual growth.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-search"></i>
        <h3>Clarity & Insight</h3>
        <p>Gain profound insights into your life's journey, uncovering answers to your past, present, and future.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-comments"></i>
        <h3>24/7 Support</h3>
        <p>Our team is always available to provide ongoing assistance, answer questions, and offer guidance whenever you need it.</p>
      </div>
    </div>
  </div>
</section>








<div><Reviews/></div>
<div><Remedycard/></div>
{/* Other sections */}
<section id="faq-astrology">
    <div className="container">
        <h2>FAQs - Frequently Asked Questions about Shiva Nadi Astrology</h2>
        <div className="accordion">
            {[
                { 
                    question: "What is Shiva Nadi Astrology?", 
                    answer: "Shiva Nadi Astrology is an ancient form of astrology based on palm leaf manuscripts, which contain the life predictions of individuals based on their thumb impression." 
                },
                { 
                    question: "How accurate is Shiva Nadi Astrology?", 
                    answer: "Shiva Nadi Astrology is known for its high level of accuracy, providing detailed insights into an individual's past, present, and future based on specific astrological techniques." 
                },
                { 
                    question: "What information is required for a Shiva Nadi reading?", 
                    answer: "Typically, a thumb impression is required to initiate the reading. This helps us locate the specific palm leaf containing the details about your life." 
                },
                { 
                    question: "Can Shiva Nadi Astrology predict my future?", 
                    answer: "Yes, Shiva Nadi Astrology can provide insights into your future, including career, relationships, health, and more, based on ancient manuscripts." 
                },
                { 
                    question: "How does a Shiva Nadi reading work?", 
                    answer: "A Shiva Nadi reading involves locating your specific palm leaf, which reveals detailed information about your life, including events that have already occurred and those yet to come." 
                },
                { 
                    question: "Are there any remedies suggested in Shiva Nadi Astrology?", 
                    answer: "Yes, specific remedies such as mantras, rituals, or spiritual practices may be suggested to improve various aspects of your life as per the astrology reading." 
                },
                { 
                    question: "Is Shiva Nadi Astrology different from other forms of astrology?", 
                    answer: "Yes, it is unique as it involves ancient palm leaf manuscripts and thumb impressions to access personal details, making it different from conventional astrological practices." 
                },
            ].map((faq, index) => (
                <div className="accordion-item" key={index}>
                    <div className="accordion-header" onClick={() => toggleFaq(index)}>
                        <h3>{faq.question}</h3>
                        <i className={`icon fas fa-chevron-${openFaq === index ? "up" : "down"}`}></i>
                    </div>
                    <div className={`accordion-content ${openFaq === index ? "open" : ""}`}>
                        <p>{faq.answer}</p>
                    </div>
                </div>
            ))}
        </div>
    </div>
</section>


<section id="contact-info">
  <h2>Contact Us</h2>
  <div class="contact-container">
    <div class="contact-item">
      <i class="fas fa-map-marker-alt"></i>
      <h3>Office Address</h3>
      <p>LIG- B, Plot No: 204, Dr. AS Rao Nagar Rd, beside SUB POST OFFICE, Anupuram Colony, A. S. Rao Nagar, Hyderabad, Secunderabad, Telangana 500062</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact</h3>
      <p>Phone: +91 74021 67580<br/>Email:shivanadiastrologer@gmail.com</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-map"></i>
      <h3>Map</h3>
      <p>
      <a href="https://www.google.com/maps?q=LIG-+B,+Plot+No:+204,+Dr.+AS+Rao+Nagar+Rd,+beside+SUB+POST+OFFICE,+Anupuram+Colony,+A.+S.+Rao+Nagar,+Hyderabad,+Secunderabad,+Telangana+500062" target="_blank">View on Google Maps</a>

      </p>
    </div>
  </div>
</section>

<section id="opening-hours">
  <h2>Opening Hours</h2>
  <table class="hours-table">
    <thead>
      <tr>
        <th>Day</th>
        <th>Time</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Monday to Saturday
        </td>
        <td>
          <i class="fas fa-clock"></i> 10 AM - 7 PM
          <br/>
          <i class="fas fa-utensils"></i> Lunch: 2 PM - 3 PM
        </td>
      </tr>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Sunday
        </td>
        <td>
          <i class="fas fa-times-circle"></i> Closed
        </td>
      </tr>
    </tbody>
  </table>
</section>



    <div><Footer /></div>
  </div>
  </div>
  )
}
